import api from './AxiosInstance';

export class TypesBenefsService {
  getAllTypesBenefs = async () => {
    try {
      const response = await api.get(`/Benef/typeBenef/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllTypesDoc = async () => {
    try {
      const response = await api.get(`/Document/getTypeDocIPM`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  addTypesBenefs = async (newPrestation) => {
    try {


      const response = await api.post(`/Benef/typeBenef/add`, newPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  addTypesDoc = async (newPrestation) => {
    try {


      const response = await api.post(`/Document/getTypeDoc/add`, newPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  //

  updateTypesBenefs = async (updatedPrestation) => {
    try {


      const response = await api.put(`/Benef/typeBenef/update`, updatedPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  updateTypesDoc = async (updatedPrestation) => {
    try {


      const response = await api.put(`/Document/getTypeDoc/update`, updatedPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };
  ///Document/getTypeDoc/update
  deleteTypesBenefs = async (prestationId) => {
    try {

      const response = await api.delete(`/Benef/typeBenef/delete/${prestationId}`)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };

  deleteTypesDoc = async (prestationId) => {
    try {

      const response = await api.delete(`/Document/getTypeDoc/delete/${prestationId}`)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };
}


